export default __webpack_public_path__ + "static/media/Mark-6-HUD-Omega Widget.07680854.jpg";